<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false" role="dialog"  [attr.aria-labelledby]="'my-modal-title'" aria-describedby="my-modal-title">
    <div class="modal-header">
        <h3 class="modal-title pull-left" id="my-modal-title">{{'COVERAGE_TUTORIAL_TITLE' | globalTranslate}}</h3>

        <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
            <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="" aria-hidden="true"/>
        </button>
    </div>
    <div class="modal-body">
        <p>{{'COVERAGE_TUTORIAL_DESC' | globalTranslate}}</p>
    </div>
    <div class="modal-footer d-block">
        <div class="action-container">
            <button type="button" id="dialog" class="btn btn-block btn-secondary btn-start" (click)="onStart()">{{'START_TUTORIAL' | globalTranslate}}</button>
        </div>
    </div>
</div>